export enum LiveChatConfig {
    NEW_TAB = "new_tab",
    POP_UP = "pop_up",
}
